<div class="container">
  <h2>{{"WORKOUT.WORKOUT-EXE.NEXT-PHASE"| translate}}:</h2>

  <p class="phase-name">{{phaseName}}</p>

  <div class="circle-container">
    <svg style="margin-inline: auto" width="240" height="240" viewBox="0 0 240 240" xmlns="http://www.w3.org/2000/svg">

      <circle cx="120" cy="120" r="116" stroke="#e6e6e6" stroke-width="8" fill="none" />
      <circle cx="120" cy="120" r="116" stroke="#db3687" stroke-width="8" fill="none"
        [attr.stroke-dasharray]="circumference" [attr.stroke-dashoffset]="offset" stroke-linecap="round"
        transform="rotate(-90 120 120)" />
    </svg>

    <div class="time">
      {{remainingTime * 1000 | date: 'mm:ss'}}
    </div>
  </div>
  <div class="footer-position">
    <button class="its-button" (click)="clearTimer()">{{"WORKOUT.WORKOUT-EXE.NEXT-BTN"| translate}}</button>
  </div>
</div>
